import React from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Text, View } from "native-base";
import { X } from "lucide-react-native";

import { PressableWrap } from "../../Buttons/PressableColorWrap/PressableColorWrap";

type ExpandedImageHeaderProps = {
  title?: string;
  currentIndex: number;
  total: number;
  scaleAll: number;
  onClose: () => void;
  topBarStyle: StyleProp<ViewStyle>;
  topBarLeftStyle: StyleProp<ViewStyle>;
  topBarRightStyle: StyleProp<ViewStyle>;
  titleTextStyle: any;
  counterTextStyle: any;
  topBarIconWrapStyle: StyleProp<ViewStyle>;
};

const ExpandedImageHeader: React.FC<ExpandedImageHeaderProps> = ({
  title,
  currentIndex,
  total,
  scaleAll,
  onClose,
  topBarStyle,
  topBarLeftStyle,
  topBarRightStyle,
  titleTextStyle,
  counterTextStyle,
  topBarIconWrapStyle,
}) => {
  return (
    <View style={topBarStyle}>
      <View style={topBarLeftStyle}>
        <Text numberOfLines={1} style={titleTextStyle}>
          {title || "Просмотр изображения"}
        </Text>
      </View>

      <View style={topBarRightStyle}>
        <Text style={counterTextStyle}>
          {currentIndex + 1} / {total}
        </Text>

        <PressableWrap onPress={onClose}>
          <View style={topBarIconWrapStyle}>
            <X size={20 * scaleAll} color="white" />
          </View>
        </PressableWrap>
      </View>
    </View>
  );
};

export default React.memo(ExpandedImageHeader);
